/**
 * Break-glass frame for the review screen.
 *
 * It measures its own width and republishes the result as a `.quote-card-narrow`
 * class, which is how the shared quote-column primitives decide to stack
 * (`in-[.quote-card-narrow]:` variants). A measured ref plus a class name that
 * *other* components select on cannot be expressed with layout primitives — the
 * class is the API here, not the styling.
 *
 * The bottom gutter rides along because it belongs to the frame rather than to
 * the last thing inside it.
 */

import type { ReactNode } from "react";
import { useWidth } from "@/Shared/Hooks/useWidth";

interface BookShipmentReviewFrameProps {
  children: ReactNode;
}

export function BookShipmentReviewFrame({
  children,
}: BookShipmentReviewFrameProps) {
  const [reviewRef, reviewWidth] = useWidth();
  const narrowColumns = reviewWidth > 0 && reviewWidth < 800;

  return (
    <div
      ref={reviewRef}
      className={`flex w-full flex-col items-start pb-6 ${
        narrowColumns ? "quote-card-narrow" : ""
      }`}
    >
      {children}
    </div>
  );
}
